export default __webpack_public_path__ + "static/media/whereby.275b62db.png";